import { Grid, Typography } from "@mui/material";

import { ROUTES } from "@/utils/navigation";
import { whyTrackmateCards } from "@/utils/staticData/homeData";

import ArrowRightIcon from "@/assets/icons/arrow-long-right.svg?react";
import ButtonWithIcon from "@/components/UI-Kit/ButtonWithIcon";
import Section from "@/components/Section";
import TrackmateCard from "./components/TrackmateCard";

const WhyTrackmate = () => {
  return (
    <Section
      pt={{ xs: 2.5, md: 12.5, lg: 17.5 }}
      pb={{ xs: 7.5, md: 12.5, lg: 17.5 }}
    >
      <Typography variant="h2" color="text.primary" mb={2} maxWidth={506}>
        Why Trackmate?
      </Typography>
      <Typography
        variant="subtitle1"
        color="text.secondary"
        mb={{ xs: 5, md: 8, lg: 10 }}
        maxWidth={506}
      >
        Trackmate GPS is the most advanced GPS tracking system on the market today. It’s also the simplest and most affordable way to monitor your assets, cargo, equipment, or fleet.
      </Typography>

      <Grid container spacing={{ xs: 3, lg: 4 }} mb={3.5}>
        {whyTrackmateCards.map((data, index) => (
          <Grid item xs={12} sm={6} lg={3} key={index}>
            <TrackmateCard {...data} />
          </Grid>
        ))}
      </Grid>

      <ButtonWithIcon
        label="Learn more"
        IconComponent={ArrowRightIcon}
        isLink={true}
        to={`${ROUTES.whyTrackmate}`}
      />
    </Section>
  );
};

export default WhyTrackmate;
